import BlokWrap from "@/components/bloks/BlokWrap";
import { FormatDate } from "@/components/ui/Date";
import type { BlokIntro } from "@/storyblok";
import type { BlokProps } from "@frend-digital/storyblok";
import { clsx } from "@frend-digital/ui";
import { AssetBlok, multiAssetToSingleAsset, sizes } from "../Asset";
import { MediaLink } from "../MediaLink";
import styles from "./Intro.module.css";

export const IntroBlok = ({
	blok,
	preview,
	firstPublishedAt,
	...rest
}: BlokProps<BlokIntro> & { "data-header"?: boolean }) => {
	return (
		<BlokWrap {...rest} editable={blok} as="section" className={styles.root}>
			<div className={styles.subgrid}>
				<h1 className={clsx(styles.title, blok.small && styles.small)}>{blok.title}</h1>

				{(blok.preamble || firstPublishedAt) && (
					<p className={styles.preamble}>
						{blok.preamble || (firstPublishedAt && <FormatDate>{firstPublishedAt}</FormatDate>)}
					</p>
				)}
				{blok.description && <p className={styles.description}>{blok.description}</p>}
			</div>

			{!!blok.media?.length && (
				<div className={styles.media}>
					<MediaLink link={blok.mediaLink} contentType={blok.component} itemId={blok._uid}>
						<AssetBlok
							muted
							autoPlay
							loop
							source={multiAssetToSingleAsset(blok.media)}
							quality={100}
							sizes={sizes(100)}
						/>
					</MediaLink>
				</div>
			)}
		</BlokWrap>
	);
};
